import { shareModalActionTypes } from './Constants';
import * as shareActions from './Actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import * as errorHandlerActions from '../../errorHandler/Actions';

export default function* () {
	yield all([takeLatest(shareModalActionTypes.GET_SHARE_LINK, handleGetShareLinkRequest)]);
}

export function* handleGetShareLinkRequest({ payload }) {
	try {
		const { data: requestData } = payload || {};
		const { id, type, subType } = requestData || {};

		let url = '';

		switch (type) {
			case 'video':
				url = `summaries/${id}/video_sharing_options`;
				break;
			case 'song':
				url = `public/donk_ai/${id}/song_sharing_options`;
				break;
			case 'results':
				url = `${subType}/${id}/results_sharing_options`;
				break;
			default:
				break;
		}

		const { data } = yield call(processRequest, url);

		yield put(shareActions.getShareLinkSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(shareActions.getShareLinkError());
	}
}
